// Photography roles (temporary stock placeholders — swap for the real TWSS
// photoshoot without touching layout):
//   chaise   → TYPE A: hero / flagship, Ashyla on the orange chaise (wide, offset)
//   portrait → TYPE B: close reclining/leaning editorial portrait (About, press)
//   drink    → Shi Sips ritual still
//   vinyl    → music / record still
export const IMAGES = {
  chaise:
    "https://images.unsplash.com/photo-1634517031809-b7326e83013e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwxfHxibGFjayUyMHdvbWFuJTIwbG91bmdpbmclMjBvcmFuZ2UlMjB2ZWx2ZXQlMjBjaGFpc2UlMjBlZGl0b3JpYWx8ZW58MHx8fHwxNzg5MTQ0OTYwfDA&ixlib=rb-4.1.0&q=85",
  portrait:
    "https://images.unsplash.com/photo-1692984756932-78ccee855ad4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHxlbGVnYW50JTIwYmxhY2slMjB3b21hbiUyMHJlY2xpbmluZyUyMGVkaXRvcmlhbCUyMHBvcnRyYWl0JTIwd2FybXxlbnwwfHx8fDE3ODkxNDQ5NjB8MA&ixlib=rb-4.1.0&q=85",
  drink:
    "https://images.unsplash.com/photo-1769734416095-30fbc03e7bb7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwyfHx2aW50YWdlJTIwY29ja3RhaWwlMjBiYXIlMjBjYXJ0JTIwbW9vZHklMjBhbWJlcnxlbnwwfHx8fDE3ODkxNDQ5NjB8MA&ixlib=rb-4.1.0&q=85",
  vinyl:
    "https://images.unsplash.com/photo-1558098329-a11cff621064?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwxfHx2aW55bCUyMHJlY29yZCUyMHZpbnRhZ2UlMjBhY291c3RpYyUyMGd1aXRhciUyMG11c2ljJTIwc3R1ZGlvJTIwd2FybSUyMHdvb2R8ZW58MHx8fHwxNzg3ODY5NTIwfDA&ixlib=rb-4.1.0&q=85",
};

export const YOUTUBE_URL = "https://www.youtube.com/@thatswhatshisaidshow";
export const SHI_SHEET_URL = "https://theshisheet.beehiiv.com";
export const PRESS_EMAIL = "thatswhatshisaidpodcast@gmail.com";

export const SOCIALS = {
  youtube: YOUTUBE_URL,
  instagram: "https://www.instagram.com/thatswhatshisaidshow/",
  tiktok: "https://www.tiktok.com/@thatswhatshisaidshow",
  threads: "https://www.threads.com/@thatswhatshisaidshow",
  twitter: "https://x.com/twsswithshi",
};
export const SPOTIFY_URL = "https://open.spotify.com/show/39OujiWwqVp7OFs0y8vmf4";
